import { AfterViewInit, Component, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { DashboardSalesPanelComponent } from 'src/app/components/dashboard-sales-panel/dashboard-sales-panel.component';
import { LoginLogsComponent } from 'src/app/components/login-logs/login-logs.component';
import { DocumentDetails } from 'src/app/models/Distributor';
import { AdminService } from 'src/app/services/admin.service';
import * as moment from 'moment';
@Component({
  selector: 'app-reseller-view',
  templateUrl: './reseller-view.component.html',
  styleUrls: ['./reseller-view.component.css']
})
export class ResellerViewComponent  implements AfterViewInit {
  activeTab:number=1;
  resellerForm: FormGroup;
  companyForm: FormGroup;
  id:number=0;
  documentsUploadForm:DocumentDetails[]=[];
  editUrl:any;
  canEdit : boolean = false;
  menuId:number = 0;
  menuUrl : string = "";
  @ViewChild(LoginLogsComponent) loginLogsComponent!: LoginLogsComponent;
  @ViewChild(DashboardSalesPanelComponent) dashboardSalesPanelComponent!: DashboardSalesPanelComponent;
  constructor(private fb: FormBuilder, private adminService: AdminService,private router:Router){
    let obj = this.router.getCurrentNavigation()?.extras?.state;
    if(obj)
    {
      this.id = parseInt(obj['id']);
      this.menuId = parseInt(obj['menuId'])??0;
      this.menuUrl = obj['menuUrl'];
      this.canEdit = obj['canEdit'];
      this.editUrl = obj['editUrl'];
      this.getFormData(this.id);
    }
    this.resellerForm = this.fb.group({
      "resellerFirstName": ['', [Validators.required]],
      "resellerLastName": ['', [Validators.required]],
      "resellerEmail": ['', [Validators.required, Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')]],
      "resellerMobile": ['', [Validators.required, Validators.pattern('[0-9]{10}')]],
      "resellerCountryCode": ['91', [Validators.required]],
      "resellerStatus": ['1', [Validators.required]],
      "resellerId": ['0'],
      "resellerDOB": ['', [Validators.required]],
      "resellerGender": ['', [Validators.required]],
      "userId": ['0'],
      "lastLogin":['']
    });

    this.companyForm = this.fb.group({
      "companyId": ['0'],
      "companyName": ['', [Validators.required]],
      "companyPancard": ['', [Validators.required,Validators.pattern('[A-Za-z]{5}[0-9]{4}[A-Za-z]{1}')]],
      "companyGSTIN": ['', [Validators.required]],
      "companyLicenseNo": ['', [Validators.required]],
      "companyMobileNo": ['', [Validators.required, Validators.pattern('[0-9]{10}')]],
      "companyCountryCode": ['91', [Validators.required]],
      "companyEmail": ['', [Validators.required, Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')]],
      "companyStreetAddress": ['', [Validators.required]],      
      "companyPincode": ['', [Validators.required,Validators.pattern('[0-9]{6}')]],
      "companyStateId": [''],
      "companyState": ['', [Validators.required]],
      "companyCityId": [''],
      "companyCity": ['', [Validators.required]],
      "companyStatus": ['1', [Validators.required]],
      "userId": ['0']
    });
  }
  get resellerFormControl() {
    return this.resellerForm.controls;
  }
  get companyDetailsFormControl() {
    return this.companyForm.controls;
  }
  ngOnInit(): void {
    
  }

  ngAfterViewInit() {
    if(this.resellerFormControl['userId'].value > 0){
      this.loginLogsComponent?.getLoginLogs(this.resellerFormControl['userId'].value,'');//'4CBC43DAC4F4470BA73D3CF7C535B65C'); //this.generalService.getUniqueuserid());
    }
    this.bindLineChartDataPolicySold();
  }

 async  getFormData(id:number)
  {
    const res = await this.adminService.GetResellerById(id);  
      if (res != null && res.result) {

        this.resellerForm.patchValue(res.result);
        this.companyForm.patchValue(res.result.companyDetails);
        this.documentsUploadForm = res.result.userDocuments;
        this.loginLogsComponent?.getLoginLogs(this.resellerFormControl['userId'].value,'');//'4CBC43DAC4F4470BA73D3CF7C535B65C'); //this.generalService.getUniqueuserid());
      }    
      else
      {
        // swal.fire({
        //   position: 'center',
        //   icon: 'error',
        //   title: 'Something went wrong',
        //   showConfirmButton: false,
        //   timer: 3000,
        // });
      } 
  }
  changeTab(tab:number)
  {
    this.activeTab = tab;
  }

  backBtClick(){
    this.router.navigateByUrl(this.editUrl,{ state: { id:this.id, menuId : this.menuId, menuUrl : this.menuUrl, canEdit : this.canEdit, editUrl : this.editUrl }});
  }
  
  homeBtClick(){
    this.router.navigateByUrl(this.menuUrl,{ state: { menuId:this.menuId, menuUrl : this.menuUrl }});
  }

  today = new Date();
  selectedStartDate:any = moment(this.today).add(-7, 'days').format();
  selectedEndDate:any = this.today;
  selectedDateRange:string="Past 7 Days";
  isDateRangeChanged:boolean = false;
  selectedAgentIds = "";
  policyTypeList:{text:string,value:number}[] = [{text:"Both",value:2},{text:"Offline",value:1},{text:"Online",value:0}];
  policyType:number = 0;
  async onPolicyTypeCheckOutput(event:any){
    this.policyType = event;
    this.bindLineChartDataPolicySold(true);
  }

  async onDateRangeChange(selectedValues:any) {
    if(selectedValues?.length > 0){
      let dataArray = selectedValues.split('::');
      if(dataArray?.length > 2){
        this.selectedStartDate = dataArray[0];
        this.selectedEndDate = dataArray[1];
        this.selectedDateRange = dataArray[2];

        this.isDateRangeChanged  = true;
        this.selectedAgentIds = '';
        setTimeout(() => {
          this.bindLineChartDataPolicySold();
        }, 100);
      }
    }    
  }

  bindLineChartDataPolicySold(policyTypeCahnge=false){
    if(this.dashboardSalesPanelComponent != undefined){
      this.dashboardSalesPanelComponent.isDateRangeChanged = this.isDateRangeChanged;
      this.dashboardSalesPanelComponent.bindLineChartDataPolicySoldCall(moment(this.selectedStartDate).format('YYYY-MM-DD'),moment(this.selectedEndDate).format('YYYY-MM-DD'),this.policyType,policyTypeCahnge,"",this.id?.toString());
      this.isDateRangeChanged = false;
    }
  }
}
